// tslint:disable
import {LAYERS_ID, LAYERS_SQL} from './constants';
import {GeoJsonLayer, IconLayer} from '@deck.gl/layers';
import {DataFilterExtension} from '@deck.gl/extensions';
import {Colors} from '../../../common/const';
import {INFORMO_INTENSITY_COLORS, INFORMO_INTENSITY_RANGES} from '../../../cities/informo/informo.const';
import {hexToRgba} from '../../../common/utils';
import {ALL_WAZE_SUBTYPES} from '../../../common/waze-subtypes';
import {environment} from '../../../../environments/environment';
import {RealTimePopupComponent} from '../real-time-popup/real-time-popup.component';
import {TrafficsLightPopupComponent} from '../../../cities/informo/traffics-light-popup/traffics-light-popup.component';
import * as mapbox from '@carto/mapbox-gl';
import {TrafficIntensityPopupComponent} from '../../../cities/informo/traffics-intensity-popup/traffics-intensity-popup.component';
import {RealTimeServiceLevelsPopupComponent} from '../real-time-service-levels-popup/real-time-service-levels-popup.component';
import {BaseLayerMVTDeck} from '../../../common/layers/baseLayerMVTDeck';
import {MvtService} from '../../../common/services/mvt.service';

// tslint:enable

export class WazeLayer extends BaseLayerMVTDeck {
    lineLayerTypeVisible = [];
    lineLayerSourceVisible = [];
    poisLayerTypeVisible = [];
    poisLayerSourceVisible = [];
    __hoverPopup;
    icon_mapping: any;
    icon_atlas = '';
    layers = {
        [LAYERS_ID.WAZE_LINE_LAYER]: (
            new GeoJsonLayer({
                id: LAYERS_ID.WAZE_LINE_LAYER,
                getFillColor: [140, 207, 215, 100],
                onClick: (e) => this._clickOnLineLayer(e),
                pickable: true,
                getLineColor: f => this.getLineLayerColor(f.properties),
                getLineWidth: _ => this.getLineLayerWidth(),
                lineWidthMinPixels: 2,
                getFilterValue: d => {
                    return [
                        Number(this.mapContext.mapInstance.getZoom() > environment.featuresInitialZoom),
                        Number(this.lineLayerSourceVisible.includes(d.properties.source)),
                        Number(this.lineLayerTypeVisible.includes(d.properties.layer))
                    ];
                },
                filterRange: [
                    [1, 1],
                    [1, 1],
                    [1, 1],
                ],
                extensions: [new DataFilterExtension({filterSize: 3})],
                updateTriggers: {
                    getFilterValue: [
                        this.mapContext ? this.mapContext.mapInstance.getZoom() : 1,
                        this.lineLayerSourceVisible,
                        this.lineLayerTypeVisible
                    ]
                }

            })
        ),
        [LAYERS_ID.WAZE_POIS_LAYER]: (
            new GeoJsonLayer({
                id: LAYERS_ID.WAZE_POIS_LAYER,
                onClick: (e) => this._clickOnPoisLayer(e),
                onHover: (e) => this._hoverLineLayer(e),
                pickable: true,
                overLayerId: LAYERS_ID.WAZE_LINE_LAYER,
                renderSubLayers: props => new IconLayer({
                    ...props,
                    id: props.id + LAYERS_ID.WAZE_POIS_ICONS_LAYER,
                    getPosition: d => d.geometry.coordinates,
                    getSize: f => this.getPoisLayerWidth(f.properties),
                    iconAtlas: this.icon_atlas,
                    iconMapping: this.icon_mapping,
                    getIcon: f => this.getPoisLayerIcon(f.properties),
                    getFilterValue: d => {
                        return [
                            this.mapContext.mapInstance.getZoom() > environment.featuresInitialZoom ? 1 : 0,
                            Number(this.poisLayerSourceVisible.includes(d.properties.source)),
                            Number(this.poisLayerTypeVisible.includes(d.properties.type))
                        ];
                    },
                    filterRange: [
                        [1, 1],
                        [1, 1],
                        [1, 1]
                    ],
                    extensions: [new DataFilterExtension({filterSize: 3})],
                    updateTriggers: {
                        getFilterValue: [
                            this.mapContext ? this.mapContext.mapInstance.getZoom() : 1,
                            this.poisLayerSourceVisible,
                            this.poisLayerTypeVisible
                        ]
                    }
                }),
            })
        ),
    };

    constructor(
        private city,
        private mvtService: MvtService
    ) {
        super(LAYERS_ID.WAZE_LAYER);
        this.mvtService.getIconAtlas().then(i => {
            this.icon_atlas = i.atlas;
            this.icon_mapping = i.mapping;
        });
    }

    updateFilters(city) {
        return new Promise((resolve, reject) => {
            this.city = city;
            this.setLayerFilters();
            this.update(LAYERS_ID.WAZE_LINE_LAYER, {
                updateTriggers: {
                    getFilterValue: [
                        this.mapContext.mapInstance.getZoom(),
                        this.lineLayerSourceVisible,
                        this.lineLayerTypeVisible
                    ]
                }
            });
            this.update(LAYERS_ID.WAZE_POIS_LAYER, {
                updateTriggers: {
                    getFilterValue: [
                        this.mapContext.mapInstance.getZoom(),
                        this.poisLayerSourceVisible,
                        this.poisLayerTypeVisible
                    ]
                }
            });
            resolve(this.readViewPortFeatures());
        });
    }

    updateSource() {
        this.mapContext.addToLoading(this);
        this.setLayerFilters();
        return this.getDataLayer().then((layers) => {
            layers.forEach(l => {
                this.update(l.id, {data: l.tiles});
            });
            this.mapContext.removeFromLoading();
            return this.readViewPortFeatures();
        });
    }

    setLayerFilters() {
        const city = this.city.find(c => c.mode === 'live');
        this.lineLayerTypeVisible = city.types
            .filter(type =>
                [
                    'SERVICE_LEVELS',
                    'INTENSITY_LEVELS',
                    'JAM'
                ].includes(type.idText) && type.showing
            ).map(type => type.idText);

        this.poisLayerTypeVisible = city.types
            .filter(type =>
                [
                    'JAM',
                    'EVENT',
                    'CONSTRUCTION',
                    'ACCIDENT',
                    'WEATHERHAZARD',
                    'CAMERA',
                    'TRAFFIC_LIGHT',
                    'ACOUSTIC_WARNINGS'
                ].includes(type.idText) && type.showing
            ).map(type => type.idText);
        this.poisLayerSourceVisible = this.lineLayerSourceVisible = city.sources
            .filter(src =>
                src.showing
            ).map(src => src.id);
    }

    getDataLayer() {
        const p = [];
        Object.keys(this.layers).forEach(layer_id => {
            const tiles = this.mvtService.getMVT(
                layer_id,
                LAYERS_SQL[layer_id]()
            );

            p.push(tiles);
        });

        return Promise.all(p).then(values => {
            return Object.keys(this.layers).map((id, idx) => ({
                id,
                tiles: values[idx]
            }));
        });
    }

    getLineLayerColor(properties) {
        let color = '#000';
        if (properties.layer === 'JAM') {
            const colors = [
                Colors.level1,
                Colors.level2,
                Colors.level3,
                Colors.level4,
                Colors.level5
            ];
            const idx = Math.min(Math.max(0, properties.level - 1), colors.length);
            color = colors[idx];
        } else if (properties.layer === 'INTENSITY_LEVELS') {
            const intensity = [1, 2, 3, 4, 5, 6, 7, 8, 9];
            const colors = [
                INFORMO_INTENSITY_COLORS.intensity1,
                INFORMO_INTENSITY_COLORS.intensity2,
                INFORMO_INTENSITY_COLORS.intensity3,
                INFORMO_INTENSITY_COLORS.intensity4,
                INFORMO_INTENSITY_COLORS.intensity5,
                INFORMO_INTENSITY_COLORS.intensity6,
                INFORMO_INTENSITY_COLORS.intensity7,
                INFORMO_INTENSITY_COLORS.intensity8,
                INFORMO_INTENSITY_COLORS.intensity9,
            ];
            color = colors[intensity.indexOf(Number(properties.intensity))];
        } else {
            const categories = ['FLUID', 'SLOW', 'HOLD', 'CONGESTION', 'CLOSED', 'NODATA'];
            const colors = [
                Colors.fluid,
                Colors.level2,
                Colors.level3,
                Colors.level5,
                Colors.closed,
                Colors.nodata
            ];
            color = colors[categories.indexOf(properties.status)];
        }

        return hexToRgba(color);
    }

    getLineLayerWidth() {
        const zoom = this.mapContext.mapInstance.getZoom();
        return zoom > 12 && zoom < 16 ? 5 : 3;
    }

    getPoisLayerWidth(properties) {
        const zoom = this.mapContext.mapInstance.getZoom();
        let size = 10;
        const big = zoom >= 10 && zoom <= 14;
        if (properties.type === 'ACOUSTIC_WARNINGS') {
            size = big ? 18 : 10;
            // blend(10, 18, linear(zoom(), 10, 14)),

        } else if (properties.type === 'TRAFFIC_LIGHT') {
            size = big ? 24 : 16;
            // blend(16, 24, linear(zoom(), 10, 14))
        } else {
            size = big ? 30 : 24;
            // blend(24, 30, linear(zoom(), 10, 14)),
        }
        return size * 1.50;
    }

    getPoisLayerIcon(properties) {
        let image = '';
        let type_levels = [];
        let images = [];
        if (properties.layer === 'JAM') {
            images = [
                'jam-low',
                'jam-medium',
                'jam-high',
            ];
            // buckets($level,[3,4,5]),
            const levels = [3, 4, 5];
            const idx = levels.indexOf(Number(properties.level));
            image = images[idx];
            if (!image) {
                image = properties.level < levels[0]
                    ? images[0]
                    : images[images.length - 1];
            }
        } else if (properties.layer === 'ALERTS') {
            type_levels = ALL_WAZE_SUBTYPES
                .map(wb => wb.name)
                .concat([
                    'CONSTRUCTION-madrid',
                    'EVENT-madrid',
                    'ALERT-madrid',
                    'ACCIDENT-madrid'
                ]);
            images = ALL_WAZE_SUBTYPES
                .map(wb => wb.value)
                .concat([
                    'obras-madrid',
                    'event-madrid',
                    'hazard-madrid',
                    'accidente-madrid',
                ]);
            const idx = type_levels.indexOf(properties.type_level);
            image = images[idx];
            if (!image) {
                image = 'marker-goal';
            }

        } else {
            const type = [
                'CAMERA',
                'TRAFFIC_LIGHT',
                'ACOUSTIC_WARNINGS'
            ];
            images = [
                'camera',
                'traffic-light',
                'circle-acoustic'
            ];
            const idx = type.indexOf(properties.type);
            image = images[idx];
        }
        return image.split('/').slice(-1).join().split('.').shift();
    }

    _clickOnLineLayer(event) {
        if (event.object) {
            const feature = event.object;
            const layerName = feature.properties.layer;
            let popup = null;
            let properties = feature.properties;
            if (layerName === 'INTENSITY_LEVELS') {
                popup = TrafficIntensityPopupComponent;
                properties = {
                    intensity: INFORMO_INTENSITY_RANGES[Number(feature.properties.intensity) - 1],
                };
            } else if (layerName === 'SERVICE_LEVELS') {
                popup = RealTimeServiceLevelsPopupComponent;
                properties = {
                    status: feature.properties.status,
                };
            } else {
                popup = RealTimePopupComponent;
                properties = {
                    type: feature.properties.type,
                    street: !feature.properties.street || feature.properties.street === 'NULL' ? '-' : feature.street,
                    speed: feature.properties.speed,
                    delay: feature.properties.delay,
                    length: feature.properties.roadlength,
                    level: feature.properties.level,
                };
            }
            this.openPopup(properties, popup, {lng: event.coordinate[0], lat: event.coordinate[1]});
        }
    }

    _clickOnPoisLayer(event) {
        const feature = event.object;
        const layerName = feature.properties.layer;
        let popup = null;
        let properties: any = {
            type: feature.properties.type,
            street: !feature.properties.street || feature.properties.street === 'NULL' ?
                '-' : feature.properties.street,
        };
        if (layerName === 'ALERTS') {
            popup = RealTimePopupComponent;
            if (['ACCIDENT', 'WEATHERHAZARD'].includes(feature.properties.type)) {
                properties = {
                    ...properties,
                    subtype: feature.properties.subtype,
                    reportdescription: feature.properties.description,
                    start: feature.properties.time_start
                        ? feature.properties.time_start * 1000
                        : null,
                    finish: feature.properties.time_finish
                        ? feature.properties.time_finish * 1000
                        : null,
                };
            } else if (['CONSTRUCTION', 'EVENT'].includes(feature.properties.type)) {
                properties = {
                    ...properties,
                    start: feature.properties.time_start
                        ? feature.properties.time_start * 1000
                        : null,
                    finish: feature.properties.time_finish
                        ? feature.properties.time_finish * 1000
                        : null,
                    street: !feature.properties.street || feature.properties.street === 'NULL' ?
                        feature.properties.description : feature.properties.street,
                };
            }

        } else if (layerName === 'JAM') {
            popup = RealTimePopupComponent;
            properties = {
                ...properties,
                speed: feature.properties.speed,
                delay: feature.properties.delay,
                length: feature.properties.roadlength,
                level: feature.properties.level,
            };
        } else if (['TRAFFIC_LIGHT', 'CAMERA'].includes(feature.properties.type)) {
            popup = TrafficsLightPopupComponent;
            properties = {
                ...properties,
                status: (layerName === 'CAMERA') ? undefined : feature.properties.active,
                camera: feature.properties.camera,
            };
        }
        this.openPopup(properties, popup, {lng: event.coordinate[0], lat: event.coordinate[1]});
    }

    _hoverLineLayer(event) {
        if (!this.__hoverPopup) {
            this.__hoverPopup = new mapbox.Popup({
                closeOnClick: false,
                closeButton: false
            });
        }
        this.hover(event.object !== undefined);
        if (event.object) {
            const feature = event.object.properties;
            const layerName = feature.layer;

            if (layerName === 'TRAFFIC_LIGHT' || layerName === 'CAMERA') {
                const id = feature.cod_id;
                const expresion = /(\d\d)(\d+)/g;
                const cid = id.replace(expresion, '$1-$2');
                this.__hoverPopup.setHTML(`
          <div class="map-popup-hover">
          ${cid} ${feature.street}
          </div>
        `);
                this.__hoverPopup.setLngLat([event.coordinate[0], event.coordinate[1]]);
                if (!this.__hoverPopup.isOpen()) {
                    this.__hoverPopup.addTo(this.mapContext.mapInstance);
                }
            }
        } else {
            if (this.__hoverPopup) {
                this.__hoverPopup.remove();
            }
        }
    }

    protected readViewPortFeatures() {
        const types = [
            {
                layer: LAYERS_ID.WAZE_POIS_LAYER,
                group_by: 'layer',
                allowed: ['JAM', 'CAMERA', 'TRAFFIC_LIGHT', 'ACOUSTIC_WARNINGS'],
            },
            {
                layer: LAYERS_ID.WAZE_POIS_LAYER,
                group_by: 'type',
                allowed: ['CONSTRUCTION', 'ALERTS', 'ACCIDENT', 'WEATHERHAZARD'],
            },
            {
                layer: LAYERS_ID.WAZE_LINE_LAYER,
                group_by: 'layer',
                allowed: ['SERVICE_LEVELS', 'INTENSITY_LEVELS', 'JAM'],
            },
        ];
        const mode = 'live';
        const city = this.city.find(c => c.mode === mode);
        types.forEach(t => {
            this.countViewportFeatures(city, t.layer, t.allowed, 'types', t.group_by);
        });
        return city;
    }

}



// WEBPACK FOOTER //
// ./src/app/real-time/real-time/layers/wazeLayer.ts